module.exports = "\n<div class=\"comp-countries-map-container\" @click.prevent=\"onClick\" @touch.prevent=\"onClick\">\n  <countries-map :active_country_codes=\"active_country_codes\" :country_links=\"country_links\" :zoom_state=\"zoom_state\" :center_lat=\"center_lat\" :center_lng=\"center_lng\" interactive=\"false\"></countries-map>\n  <div class=\"interactive-map-info-overlay\"><i class=\"mdi mdi-arrow-expand-all\"></i><span>Interaktive Karte öffnen</span></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/countries_map_container/index.pug
// module id = 690
// module chunks = 4